import store from '../store';

export function nextStep() {
    return { type: 'GAMEGUIDE_NEXT_STEP', payload: { userLoggedIn: store.getState().user.loggedIn } };
}

export function prevStep() {
    return { type: 'GAMEGUIDE_PREV_STEP' };
}

export function selectStep(step) {
    return { type: 'GAMEGUIDE_SELECT_STEP', payload: step };
}

export function forceSelectStep(step) {
    return { type: 'FORCE_GAMEGUIDE_SELECT_STEP', payload: step };
}

export function toggleGuide() {
    return { type: 'GAMEGUIDE_TOGGLE' };
}

export function setPublishState(publishState = 0) {
    return { type: 'GAMEGUIDE_PUBLISH_ERROR', payload: publishState };
}
